var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2236 6.30952V4.07268C10.2236 3.45531 10.7246 2.95426 11.342 2.95426H12.4604V0.158203H10.2236C8.37035 0.158203 6.86831 1.66024 6.86831 3.51347V6.30952H4.63147V9.10557H6.86831V18.0529H10.2236V9.10557H12.4604L13.5788 6.30952H10.2236Z",
    fill: "#39373A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8947,
    height: 17.8947,
    fill: "white",
    transform: "translate(0.157837 0.158203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bcd196c42ba4da9c4878ffae3423909c.svg";
export { ForwardRef as ReactComponent };